import { AdminUserTenant } from '../api/types/GraphQL';

/**
 * How a tenant is NAMED and ORDERED, for every surface that lists tenants —
 * the shell switcher and the Settings "Environment access" block.
 *
 * Both carried a byte-identical copy of the label fallback, and only one of
 * them sorted, so the same 13 tenants appeared alphabetically in the top bar
 * and in raw API order in Settings.
 */

/**
 * AdminUserTenant.name is a deprecated denormalized copy on the user↔tenant
 * association row; tenantUpdate writes the federated tenantInfo.name, so that
 * is what a rename actually changes. Falls back to the legacy field so a
 * tenant never renders blank (NBO-2272).
 */
export function tenantLabel(tenant: AdminUserTenant | null | undefined): string {
  return tenant?.tenantInfo?.name || tenant?.name || '';
}

export function tenantInitial(tenant: AdminUserTenant | null | undefined): string {
  return tenantLabel(tenant).charAt(0).toUpperCase();
}

/**
 * Alphabetical by displayed label, case- and accent-insensitive (`sensitivity:
 * 'base'`), so "backup - restore" files under B rather than after every
 * capitalised name. Returns a new array — the input is NgRx store state and
 * `Array.prototype.sort` mutates in place.
 */
export function sortTenantsByLabel(tenants: readonly AdminUserTenant[]): AdminUserTenant[] {
  return [...tenants].sort((a, b) =>
    tenantLabel(a).localeCompare(tenantLabel(b), undefined, { sensitivity: 'base' })
  );
}
